import React from "react";
import PropTypes from "prop-types";

export default function SellQuicklySVG(props) {
  return (
    <svg
      version="1.1"
      id={props.id || ''}
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 62 62"
      fill={props.styles.fill}
      height={props.styles.height}
      width={props.styles.width}
      className={props.className || ''}
    >
      <g>
        <path
          className="st0"
          d="M62,18H36V5c0-2.8-2.2-5-5-5H5C2.2,0,0,2.2,0,5v52c0,2.8,2.2,5,5,5h26c2.8,0,5-2.2,5-5V44h26V18z M5,2h26
		c1.7,0,3,1.3,3,3v2H2V5C2,3.3,3.3,2,5,2z M31,60H5c-1.7,0-3-1.3-3-3v-3h32v3C34,58.7,32.7,60,31,60z M34,52H2V9h32v9H12v10h1
		c1.6,0,3,1.4,3,3c0,1.7-1.4,3-3,3h-1v10h22V52z M60,42H32v-2h-2v2H14v-6.1c2.3-0.5,4-2.5,4-4.9s-1.7-4.4-4-4.9V20h16v2h2v-2h28V42z
		"
        />
        <rect x="30" y="24" className="st0" width="2" height="2" />
        <rect x="30" y="28" className="st0" width="2" height="2" />
        <rect x="30" y="32" className="st0" width="2" height="2" />
        <rect x="30" y="36" className="st0" width="2" height="2" />
        <rect x="17" y="22" className="st0" width="2" height="2" />
        <rect x="21" y="22" className="st0" width="2" height="2" />
        <rect x="25" y="22" className="st0" width="2" height="2" />
        <rect x="48" y="38" className="st0" width="2" height="2" />
        <rect x="44" y="38" className="st0" width="2" height="2" />
        <rect x="52" y="38" className="st0" width="2" height="2" />
        <rect x="56" y="38" className="st0" width="2" height="2" />
        <rect x="20" y="26" className="st0" width="8" height="2" />
        <rect x="20" y="34" className="st0" width="8" height="2" />
        <rect x="20" y="30" className="st0" width="8" height="2" />
        <rect x="47" y="24" className="st0" width="11" height="2" />
        <rect x="34" y="24" className="st0" width="11" height="2" />
        <rect x="34" y="28" className="st0" width="24" height="2" />
        <rect x="34" y="32" className="st0" width="24" height="2" />
        <rect x="13" y="56" className="st0" width="10" height="2" />
        <rect x="4" y="15" className="st0" width="2" height="35" />
        <rect x="20" y="38" className="st0" width="8" height="2" />
        <rect x="16" y="38" className="st0" width="2" height="2" />
      </g>
    </svg>
  );
}

SellQuicklySVG.propTypes = {
  className: PropTypes.string,
  id: PropTypes.string,
  styles: PropTypes.shape({
    fill: PropTypes.string,
    height: PropTypes.string,
    width: PropTypes.string
  })
};
